// extracted by mini-css-extract-plugin
module.exports = {"Tag":"styles_Tag__4KyjQ"};